<div class="image-wrapper">
  <img src="{{getImage()}}" [ngStyle]="style" class="image" alt="{{alt}}">
</div>

